import { Entity } from 'src/app/models/entities.model';


export class School extends Entity {
  constructor(o?: Partial<School>) {
    super(o);
  }
}
